import { Dimensions, StyleSheet, Switch, Text, View } from "react-native";
import CardItem from "./CardItem";
import * as Colors from "../styles/colors";
import * as Fonts from "../styles/typography";
import CardForm from "./CardForm";
import { IS_WEB } from "../services/Config";

const { width, height } = Dimensions.get("window");

export default function NewCard({
  setNewCard,
  newCard,
  props,
  handleSelectedCard,
  saveCard,
  setSaveCard,
}) {
  // const [saveCard, setSaveCard] = useState(false);
  const toggleSwitch = () => setSaveCard(!saveCard);

  return (
    // <KeyboardAvoidingView>
    <View style={{width: "100%"}}>
      <CardItem
        text={"Novo cartão"}
        onPressCard={() => {
          setNewCard(true);
          handleSelectedCard(null);
        }}
        style={{ marginBottom: newCard ? 0 : 8, width: "100%" }}
        hasSelect={true}
        checked={newCard}
      />
      {newCard ? (
        <View style={styles.viewNewCard}>
          <CardForm {...props} />
          {!IS_WEB ? (
            <View style={styles.viewSaveCard}>
            <Text style={styles.optionTitle}>{`Salvar cartão`}</Text>
            <Switch
              trackColor={{
                false: "#767577",
                true: Colors.SECONDARY_PALLETE[2],
              }}
              thumbColor={saveCard ? Colors.SECONDARY : "#f4f3f4"}
              ios_backgroundColor="#3e3e3e"
              onValueChange={toggleSwitch}
              value={saveCard}
            />
            </View>
          ) : (
            <View style={styles.viewSaveCard}></View>
          )}
        </View>
      ) : null}
    </View>
    // </KeyboardAvoidingView>
  );
}

const styles = StyleSheet.create({
  optionTitle: {
    fontSize: Fonts.FONT_SIZE_20,
    fontWeight: "bold",
    marginRight: 8,
  },
  viewNewCard: {
    paddingHorizontal: 16,
    borderWidth: 1,
    borderBottomStartRadius: 8,
    borderBottomEndRadius: 8,
    borderTopWidth: 0,
    marginHorizontal: 8,
    width: "95%",
    backgroundColor: Colors.SNOW
  },
  viewSaveCard: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginHorizontal: 8,
    marginVertical: 8
  },
});
